import React, { useState, useEffect } from 'react';
import './App.css';
import StudyListAWS from './components/StudyListAWS';
import LoginPage from './components/LoginPage';
import AUTH_CONFIG from './config/auth';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check for existing session on mount
  useEffect(() => {
    const checkAuth = () => {
      try {
        // Check both localStorage and sessionStorage
        const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
        const userData = localStorage.getItem('userData') || sessionStorage.getItem('userData');
        
        if (token && userData) {
          // Validate token before accepting session
          if (AUTH_CONFIG.validateToken(token)) {
            setUser(JSON.parse(userData));
          } else {
            // Token is invalid or expired, clear storage
            handleLogout();
          }
        }
      } catch (error) {
        console.error('Error checking auth:', error);
        // Clear potentially corrupted auth data
        handleLogout();
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    // Clear all auth data
    localStorage.removeItem('userToken');
    localStorage.removeItem('userData');
    sessionStorage.removeItem('userToken');
    sessionStorage.removeItem('userData');
    setUser(null);
  };

  // Show loading spinner while checking auth
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Show login page if not authenticated
  if (!user) {
    return <LoginPage onLogin={handleLogin} />;
  }

  // Show the main app if authenticated
  return (
    <div className="App">
      <StudyListAWS user={user} onLogout={handleLogout} />
    </div>
  );
}

export default App;
